import { ShopCollectionResponse } from '@/types';
import { convertSprdLocaleToSprdIsoLocale } from '@/utils/convertSprdLocaleToIsoLocale';
import { getParams } from '@/utils/params';
import { getRequest } from './methods/getRequest';
import { requestToJSON } from './methods/requestToJSON';

export const fetchShopCollections = (signal?: AbortSignal) =>
  requestToJSON<ShopCollectionResponse>(
    getRequest(
      `/search/omat/${convertSprdLocaleToSprdIsoLocale(getParams().locale)}/shop/${
        getParams().contextId
      }/topics`,
      {
        signal,
      }
    )
  );
